var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelBooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 14,
    fill: "#FF425E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8154 10H14.1846C11.8809 10 10 11.8809 10 14.1846V25.8154C10 28.1277 11.8809 30 14.1846 30H17.5065C17.981 30 18.3693 29.6117 18.3693 29.1372C18.3693 28.6626 17.981 28.2744 17.5065 28.2744H14.1846C12.83 28.2744 11.7256 27.17 11.7256 25.8154V14.1846C11.7256 12.83 12.83 11.7256 14.1846 11.7256H25.8154C27.17 11.7256 28.2744 12.83 28.2744 14.1846V18.3348C28.2744 18.8093 28.6626 19.1976 29.1372 19.1976C29.6117 19.1976 30 18.8093 30 18.3348V14.1846C30 11.8723 28.1191 10 25.8154 10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3348 19.9653H15.8413C15.3667 19.9653 14.9784 20.3536 14.9784 20.8281C14.9784 21.3027 15.3667 21.691 15.8413 21.691H18.3348C18.8093 21.691 19.1976 21.3027 19.1976 20.8281C19.1976 20.3536 18.8093 19.9653 18.3348 19.9653Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8499 17.5411H23.3305C23.805 17.5411 24.1933 17.1528 24.1933 16.6782C24.1933 16.2037 23.805 15.8154 23.3305 15.8154H15.8499C15.3753 15.8154 14.9871 16.2037 14.9871 16.6782C14.9871 17.1528 15.3753 17.5411 15.8499 17.5411Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8344 20.7939C27.1786 20.1468 26.1088 20.1468 25.4444 20.7939L20.2157 26.0226C20.0518 26.1865 19.9655 26.4022 19.9655 26.6352V29.1287C19.9655 29.6032 20.3538 29.9915 20.8283 29.9915H23.3219C23.5548 29.9915 23.7705 29.8966 23.9345 29.7413L29.1631 24.4868C29.4824 24.1675 29.6549 23.7361 29.6549 23.2875C29.6549 22.8302 29.4737 22.4074 29.1545 22.0881L27.843 20.7939H27.8344ZM22.9595 28.2745H21.6912V26.9975L26.6264 22.0191L27.9379 23.2702L22.9595 28.2745Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelBooking);
export default __webpack_public_path__ + "static/media/cancelBooking.f903ecef81b829f5483bb68bd5418f03.svg";
export { ForwardRef as ReactComponent };